import React from 'react'
import PropTypes from 'prop-types'
import { ButtonLink } from './elements'

const Link = ({ href, children, onClick, sx, ...props }) => {
  return (
    <ButtonLink
      to={href}
      onClick={onClick}
      style={{
        ...sx,
      }}
      {...props}
    >
      {children}
    </ButtonLink>
  )
}

Link.propTypes = {
  href: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  onClick: PropTypes.func,
}

export default Link
